import React from "react"
import { toAbsoluteUrl } from "../../../../_metronic/_helpers"
import SVG from "react-inlinesvg"
import { ICON_CONSTANTS } from "../../../../constants/ImageConstants.js"

export const Arrow = ({ direktion }) => {
  return (
    <>
      {direktion === "up" ? (
        <SVG src={toAbsoluteUrl(ICON_CONSTANTS.ARROW_UP)} />
      ) : (
        <SVG src={toAbsoluteUrl(ICON_CONSTANTS.ARROW_DOWN)} />
      )}
    </>
  )
}
